import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { Field } from '../../models/home';
import { FIELD_NAMES } from '../../constants/common';
import { handleOnChangeText } from '../../helpers/form';
import { useTranslation } from 'react-i18next';

interface Props {
    setFields: Dispatch<SetStateAction<Field[]>>;
    setCompensationFields: Dispatch<SetStateAction<Field[]>>;
}

export const useBookingInformation = ({setFields, setCompensationFields}: Props) => {
    const { t } = useTranslation();

    const enableNumberOfCompensationsRequestedField = () => {
        setCompensationFields(prevState => {
            const updatedState = prevState.map(s => {
                if (s.name === FIELD_NAMES.compensationNum) {
                    return {
                        ...s,
                        disabled: false,
                    }
                } 
                return s; 
            })
            return updatedState;
        });
    };

    const disableNumberOfCompensationsRequestedField = () => {
        setCompensationFields(prevState => {
            const updatedState = prevState.map(s => {
                if (s.name === FIELD_NAMES.compensationNum) {
                    return {
                        ...s,
                        disabled: true,
                        requiredError: '',
                        value: '1'
                    }
                } 
                return s; 
            })
            return updatedState;
        });
    };

    const handleOnChangeTextBI = (
        event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>,
        fieldName: string,
        index: number,
        otherFieldIndex: number,
        validationType: string
    ) => {
        handleOnChangeText(event, index, setFields, validationType, [otherFieldIndex], [otherFieldIndex]);
        if (event.target.value && fieldName === FIELD_NAMES.ticketNumber) {
            disableNumberOfCompensationsRequestedField();
        } else {
            enableNumberOfCompensationsRequestedField();
        }
    };

    return {
        handleOnChangeTextBI,
        t
    };
};

